<template>
  <div class="question-title d-flex justify-content-center align-items-center mb-2">
    <div class="qs-number">{{ questionNumber }}</div>

    <textarea
      name="Question input"
      rows="2"
      class="question-input"
      placeholder="Type a question..."
      :value="questionText"
      @input="$emit('input', $event.target.value)"
    ></textarea>

    <div class="attach">
      <span class="icon-attachment-clip"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Question",
  props: {
    questionNumber: {
      type: Number,
      default: 1
    },
    questionText: {
      type: String,
      default: ""
    }
  }
};
</script>


<style lang="scss" scoped>
@import "../assets/scss/variables";

.question-title {
  position: relative;
  border: 1px solid $green;
  text-align: center;
  vertical-align: middle;
  min-height: 200px;

  .question-input {
    text-align: center;
    padding: 0.4rem 0.9rem;
    color: $placeholderColor;
    border-radius: $borderRadius;
    border: none;
    outline: none;
    font-size: 20px;
    width: 80%;
    min-height: 60px;
    overflow-y: hidden;
  }

  .question-input::placeholder {
    color: $greyLight;
  }

  .qs-number {
    position: absolute;
    left: -5px;
    top: -5px;
    padding: 2px 12px;
    font-size: 22px;
    background-color: $blue;
    color: #fff;
    outline: 8px solid #fff;
    border-radius: 3px;
    text-align: center;
    vertical-align: middle;
  }

  .attach {
    position: absolute;
    right: -1px;
    bottom: -1px;
    padding: 4px 10px;
    font-size: 22px;
    background-color: $violet;
    border-radius: $borderRadius 0 0 0;
  }
}
</style>

